import { httpCreate } from './http';

const http = httpCreate('/srv/user/wechat-bind');

export const wechatBind = {
	getBindToken(params) {
		return http.get('/bindToken', { params });
	},
	getStatus(bindToken) {
		return http.get('/status', { params: { bindToken } });
	},
	getInfo() {
		return http.get('/info');
	},
	unbind() {
		return http.post('/unbind');
	},
};
